<template>
  <div class="container">
    <div class="breadcrumb z-fixed" v-if="!mode">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <span @click="canGoChat && goChat" class="go-chat">聊天</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item>健康信息</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <a-tabs
      type="line"
      v-model:activeKey="activeKey"
      animated
      :tabBarGutter="4"
      class="healthinfo-tabs"
    >
      <a-tab-pane :key="tab.component" :tab="tab.label" v-for="tab in tabs">
        <component
          class="component"
          mode=""
          :is="component[tab.component]"
          :ref="tab.ref"
          :params="{
            ucPatientId: data.ucPatientId,
            mode
          }"
        />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script setup>
import { reactive, defineProps, ref, onMounted } from 'vue'
import { tabs, component } from './hooks/useComponent'
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()
const props = defineProps({
  ucUserId: {
    type: Number,
    default: null
  },
  mode: {
    type: String,
    default: ''
  },
  canGoChat: {
    type: Boolean,
    default: true
  }
})
const data = reactive({
  ucPatientId: ''
})
// NOTE: 不能加 onMounted 方法内部元素会提前加载props内容
// onMounted(() => {
if (props.mode) {
  // eslint-disable-next-line vue/no-setup-props-destructure
  data.ucPatientId = props.ucUserId
} else {
  data.ucPatientId = route.query.ucPatientId || props.ucUserId
}
// })
const activeKey = ref('baseInfo')
// const activeKeydemo = ref('1')
// 返回聊天页
const goChat = () => {
  router.push({
    path: '/workplace',
    query: {
      activeKey: 3
    }
  })
}
// })
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  padding: 20px 20px 20px 20px;
  height: 100%;
  background: white;
  background: #fafafa;
  .breadcrumb {
    height: 44px;
    margin-bottom: 24px;
    .go-chat {
      cursor: pointer;
    }
  }
  .healthinfo-tabs {
    ::v-deep(.ant-tabs-top-content, .ant-tabs-bottom-content) {
      overflow: initial;
    }
  }
}
</style>
